import {
  Accordion as SharedAccordion,
  TwoColumnAccordion as SharedTwoColumnAccordion,
} from "@sportal/cdk";

export const Accordion = SharedAccordion;
export const TwoColumnAccordion = SharedTwoColumnAccordion;
